import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { OrganisationService } from '../../../../../DTO/Organisation/Organisation.service';
import { OrganisationDTO } from '../../../../../DTO/Organisation/OrganisationDTO';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../../material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { LocalizationPipe } from '../../../../../pipe/localization-pipe';
import { LocalizationService } from '../../../../../services/localizationService';
import {PermissionService} from "../../../../../../core/authorization/permission.service";
import {DataFilter} from "../../../../../../core/DataFilter";

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, TablerIconsModule, FormsModule, ReactiveFormsModule, LocalizationPipe]
})
export class OrganizationListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['id', 'name', 'type', 'actions'];
  dataSource = new MatTableDataSource<OrganisationDTO>([]);
  isLoading = false;
  totalItems = 0;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 50];
  filter = new DataFilter();
  searchName: string = '';
  pageIndex = 0;

  // Tablo başlıkları için eşleme
  columnHeaderMap = {
    'id': 'Organization.ID',
    'name': 'Organization.OrganizationName',
    'type': 'Organization.Type',
    'actions': 'Organization.Actions'
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private organisationService: OrganisationService,
    private router: Router,
    public localizationService: LocalizationService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.loadOrganizations(0, this.pageSize);
  }

  ngAfterViewInit(): void {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => {
        this.resetToFirstPage();
      });
    }
  }

  resetToFirstPage(): void {
    this.pageIndex = 0;
    this.loadOrganizations(0, this.pageSize);
  }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadOrganizations(this.pageIndex, this.pageSize);
  }

  loadOrganizations(page: number, pageSize: number): void {
    this.isLoading = true;
    const apiPage = page + 1;
    const params = {
      page: apiPage,
      size: pageSize,
      sortField: this.sort?.active?.toUpperCase() || 'ID',
      sortType: this.sort?.direction === 'desc' ? 'DESC' : 'ASC'
    };

    this.organisationService.filterOrganisations(params, this.filter.getFilterAsJson()).subscribe({
      next: (response: any) => {
        this.dataSource.data = response.content || [];
        this.totalItems = response.totalElements || 0;
        this.pageIndex = page;

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading organizations', error);
        this.isLoading = false;
      }
    });
  }

  applyNameFilter(): void {
    if (this.searchName && this.searchName.trim() !== '') {
      this.filter.add('name', this.searchName.trim());
    } else {
      this.filter.remove('name');
    }
    this.resetToFirstPage();
  }


  getColumnHeader(column: string): string {
    return this.columnHeaderMap[column] || column;
  }

  viewOrganizationDetails(organizationId: number): void {
    this.router.navigate(['/apps/organization/detail', organizationId]);
  }
}
